/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

import badgeStyle from "../../assets/jss/material-dashboard-pro-react/components/badgeStyle.jsx";
import { Box } from "@mui/material";
import _ from "lodash";

const Badge = React.forwardRef(function Badge({ ...props }, ref) {
  const { classes, color, children } = props;
  const rest = _.cloneDeep(props);
  delete rest.classes;
  delete rest.color;
  delete rest.children;
  return (
    <Box component={"span"} {...rest} className={classes.badge + " " + classes[color]} ref={ref}>
      {children}
    </Box>
  );
});

Badge.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(["primary", "warning", "danger", "success", "info", "rose", "gray"]),
  children: PropTypes.node,
};

export default withStyles(Badge, badgeStyle);
